// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx","715":"component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx"}[chunkId] + "-" + {"231":"be1fb83ff16342c3863d","715":"b69ea5913071025796a1"}[chunkId] + ".js";
};